var React = require('react');

function ClickAndCollectInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 1c2.1421954 0 3.8910789 1.68396847 3.9951047 3.80035966L16 5l-.0008169 1h1.1253005c.9496471 0 1.7603275.66600446 1.9556768 1.58094842l.026779.15472414 1.7333333 13.00000004c.1459841 1.0948801-.6232482 2.1007992-1.7181283 2.2467832A1.99999686 1.99999686 0 0118.8578169 23H5.14218306c-1.1045695 0-2-.8954305-2-2 0-.0884.00586092-.1767028.0175442-.2643274L4.8930606 7.73567256C5.0255422 6.74206052 5.87311116 6 6.8755164 6h1.12366666L8 5c0-2.209139 1.790861-4 4-4zm5.124 7h-1.1248169L16 11h-2l-.0008169-3H9.99918306L10 11H8l-.00081694-3H6.8755164L5.14218306 21H18.8578169L17.124 8zM12 3c-1.0543618 0-1.9181651.81587779-1.9945143 1.85073766L10 5l-.00081694 1h4.00000004L14 5c0-1.1045695-.8954305-2-2-2z"}));
}

ClickAndCollectInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ClickAndCollectInline;

ClickAndCollectInline.default = ClickAndCollectInline;
